import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Button, Card,Divider,Skeleton,Stack,Typography } from "@mui/material";
import { useContext,useState } from "react";
import { useTranslation } from "react-i18next";
import { BiError } from "react-icons/bi";
import { UserContext } from "../../../context/UserContext";
import checkBrightness from "../../../helpers/checkBrightness";
import useAssinaturaQuery from "../../../hooks/useAssinaturaQuery";
import type { ChecklistReportType } from "../../../types/reports/types";
import { DataDetailType } from "../../../types/reports/types";
import TicketListReportComponent from "../TicketListReportComponent";
import ChamadosDetalhe from "./ChamadosDetalhe";
import FooterModalDetailPrint from "./FooterModalDetailPrint";
import HeaderModalDetailPrint from "./HeaderModalDetailPrint";
import ListaAprovadores from "./ListaAprovadores";
import MapModal from "./MapModal";
import ModalDetailContent from "./ModalDetailContent";
import { HostModelType } from "../../../types/fluxo/types";
import { VisibilityOff as VisibilityOffIcon, RemoveRedEye as RemoveRedEyeIcon } from "@mui/icons-material";

export default function DataDetail({
  exibeDetalheHospedeiro,
  showRange,
  chamados,
  showNumbers,
  exibeTipo,
  radioOption,
  ocultaNomeEmpresa,
  printTemplate,
  selected,
  showScoring,
  findTeams,
  camposOcultos,
  showNotSelected,
  showHeaders,
  showHideFields,
  hideHierarchy,
  hideEquipe,
  hideUser,
  hideIdent,
  hideAprov,
  hideDate,
  hideNAplica,
  isLoading,
  showDuplicatas,
  hideFiles,
  executionIndex = 0,
}: DataDetailType) {
  const { hierarchyLabel } = useContext(UserContext);
  const { t } = useTranslation("translation");
  const [hideAllFiles, setHideAllFiles] = useState(false);
  const [hideAllImages, setHideAllImages] = useState(false);

  function toggleHideAllFiles() {
    setHideAllFiles((prev) => !prev);
  }

  function toggleHideAllImages() {
    setHideAllImages((prev) => !prev);
  }

  function HeaderItens() {
    function LabelAndValue({ label, value }: { label: string | undefined; value: string | undefined }) {
      return (
        <Stack direction="row" alignItems="flex-start" justifyContent="flex-start" spacing={0.5}>
          <Typography variant="subtitle1" fontSize={12} fontWeight={600}>
            {label}:
          </Typography>
          <Typography sx={{ wordBreak: "break-word" }} variant="subtitle1" fontSize={12}>
            {value}
          </Typography>
        </Stack>
      );
    }

    return (
      <>
        {!ocultaNomeEmpresa && (
          <Typography variant="h4" textAlign="center" sx={{ marginTop: "10px" }}>
            {selected?.nomeEmpresa}
          </Typography>
        )}
        <Card sx={{ width: "100%" }}>
          <Stack direction="row" alignItems="flex-start" justifyContent="flex-start" width="100%" padding={1.5}>
            {!selected?.preenchimentoDeslogado && (
              <Stack direction="column" alignItems="flex-start" justifyContent="flex-start" spacing={0.8} width="50%">
                {hierarchyLabel.cliente && hideHierarchy.cliente && (
                  <LabelAndValue
                    label={hierarchyLabel.cliente}
                    value={!selected?.preenchimentoDeslogado ? selected?.cliente : selected?.clienteNome}
                  />
                )}
                {hierarchyLabel.local && hideHierarchy.local && (
                  <LabelAndValue label={hierarchyLabel.local} value={!selected?.preenchimentoDeslogado ? selected?.local : selected?.localNome} />
                )}
                {hierarchyLabel.conjunto && hideHierarchy.conjunto && (
                  <LabelAndValue
                    label={hierarchyLabel.conjunto}
                    value={!selected?.preenchimentoDeslogado ? selected?.conjunto : selected?.conjuntoNome}
                  />
                )}
                {hierarchyLabel.unidade && hideHierarchy.unidade && (
                  <LabelAndValue
                    label={hierarchyLabel.unidade}
                    value={!selected?.preenchimentoDeslogado ? selected?.unidade : selected?.unidadeNome}
                  />
                )}
                {selected?.latitude && typeof selected.latitude === "number" && (
                  <Stack direction="row" alignItems="flex-start" justifyContent="flex-start" spacing={0.5}>
                    <Typography variant="subtitle1" fontSize={12} fontWeight={600}>
                      {t("checklists.printConfig.Local_Realizado")}:
                    </Typography>
                    <Typography variant="subtitle1" fontSize={12} sx={{ cursor: "pointer" }} color="info" onClick={() => setOpenMap(!openMap)}>
                      Ver mapa
                    </Typography>
                  </Stack>
                )}
                {hideIdent && <LabelAndValue label={t("Reports.modalDetailP.identifier")} value={selected?.identificador} />}
                {!showScoring && selected?.score && <LabelAndValue label="Scoring" value={selected?.scorePorcentagem ?? "-"} />}
              </Stack>
            )}
            <Stack direction="column" alignItems="flex-start" justifyContent="flex-start" spacing={0.8} width="50%">
              {!selected?.preenchimentoDeslogado && (
                <>
                  {!hideEquipe && <LabelAndValue label={t("team")} value={(findTeams && findTeams(selected?.equipes).join(", ")) || "-"} />}
                  {hideUser && <LabelAndValue label={t("profiles.user")} value={selected?.userNome ?? "-"} />}
                </>
              )}
              {hideDate.inicio && (
                <LabelAndValue label={t("checklists.printConfig.Inicio")} value={new Date(selected?.inicio as number).toLocaleString()} />
              )}
              {hideDate.fim && <LabelAndValue label={t("Reports.columns.end")} value={new Date(selected?.fim as number).toLocaleString()} />}
              {!selected?.preenchimentoDeslogado && (
                <>
                  {!showRange && selected?.range && <LabelAndValue label="Range" value={selected?.range ?? "-"} />}
                  {showHideFields && selected?.camposOcultos && camposOcultos && camposOcultos(selected?.camposOcultos)}
                  {selected?.aprovacaoStatus && selected.aprovacaoStatus !== "NA" && (
                    <LabelAndValue label="Status" value={selected?.aprovacaoStatus ?? "-"} />
                  )}
                </>
              )}
            </Stack>
          </Stack>
        </Card>
      </>
    );
  }

  const [openMap, setOpenMap] = useState(false);

  const center = {
    lat: Number(selected?.latitude) || 0,
    lng: Number(selected?.longitude) || 0,
  };

  function Assinatura({ url, aprovadoEm }: { url: string; aprovadoEm: number }) {
    const { t } = useTranslation("translation");
    const { data: assinatura, isLoading, isError } = useAssinaturaQuery(url);

    function ErroComp() {
      return (
        <Stack direction="column" justifyContent="center" alignItems="center" spacing={1.5} color="gray" width={200} height={100}>
          <BiError size={25} />
          <Typography fontSize={13} color="textDisabled" fontWeight={700} component={"span"} textAlign="center">
            {t("users.imageNotFound")}
          </Typography>
        </Stack>
      );
    }

    return (
      <>
        {isLoading ? (
          <Stack direction="column" alignItems="center" justifyContent="flex-end">
            <Skeleton variant="rounded" width={200} height={100} />
            <Skeleton variant="text" width={100} />
          </Stack>
        ) : (
          <Stack direction="column" alignItems="center" justifyContent="flex-end">
            {!isError ? <img src={assinatura ?? ""} alt="" width={200} height={100} loading="lazy" /> : <ErroComp />}
            <Typography color="textDisabled" variant="subtitle2" fontSize={11} fontWeight={600}>
              em {new Date(aprovadoEm)?.toLocaleString("pt-BR")}.
            </Typography>
          </Stack>
        )}
      </>
    );
  }

  function InfoHospedeiro({ hospedeiro }: { hospedeiro: HostModelType | undefined }) {
    function Resposta({ resposta, type }: { resposta: string | string[] | boolean | number | Date | undefined; type: string }) {
      switch (type) {
        case "text":
        case "doc":
        case "email":
        case "phone":
          return <Typography color="textDisabled" fontWeight='bold'>{resposta as string}</Typography>;
        case "number":
          return <Typography color="textDisabled" fontWeight='bold'>{Number(resposta)}</Typography>;
        case "date":
          return <Typography color="textDisabled" fontWeight='bold'>{new Date(resposta as number).toLocaleDateString()}</Typography>;
        case "list":
        case "multiple":
        case "unique":
          return (
            <>
              {Array.from(resposta as string[])?.map((item: string, index: number) => (
                <Typography color="textDisabled" fontWeight='bold' key={index}>
                  {item}
                </Typography>
              ))}
            </>
          );
        default:
          return <></>;
      }
    }

    return (
      <Card sx={{ width: "100%", padding: 2 }}>
        <Typography variant='h6' fontWeight={600} textAlign='center' sx={{textDecoration: 'underline'}}>
          {t("Reports.hostDetails")}
        </Typography>
        <Typography fontWeight='bold' color="textDisabled" sx={{ wordBreak: "break-word" }}>
          {hospedeiro?.nome}
        </Typography>
        {hospedeiro?.campos?.map((campo, index) => (
          <Stack key={index} direction="row" alignItems="flex-start" justifyContent="flex-start" spacing={0.5}>
            <Typography key={index} sx={{ wordBreak: "break-word" }}>
              {campo?.nome}:
            </Typography>
            <Typography color="textDisabled" sx={{ wordBreak: "break-word" }}>
              <Resposta resposta={campo?.resposta} type={campo?.tipo} />
            </Typography>
          </Stack>
        ))}
      </Card>
    );
  }

  function temArquivos(): boolean {
    return (
      selected?.itens?.some((item) =>
        item.ocorrenciaMultipla
          ? item.ocorrencias?.some((ocorrencia) => ocorrencia.subitens?.some((subitem) => subitem.arquivos?.length))
          : item.subitens?.some((subitem) => subitem.arquivos
          ?.length),
      ) ?? false
    );
  }

  function temImagens(): boolean {
    return (
      selected?.itens?.some((item) =>
        item.ocorrenciaMultipla
          ? item.ocorrencias?.some((ocorrencia) => ocorrencia.subitens?.some((subitem) => subitem.img?.length))
          : item.subitens?.some((subitem) => subitem.img?.length),
      ) ?? false
    );
  }

  return (
    <>
      {openMap && <MapModal openMap={openMap} setOpenMap={setOpenMap} center={center} />}
      <Stack
        className={`print-execution${executionIndex > 0 ? " print-execution--next" : ""}`}
        direction="column"
        justifyContent="flex-start"
        alignItems="stretch"
        spacing={1.4}
        width="100%"
        sx={{ marginTop: "20px" }}>
        <HeaderModalDetailPrint printTemplate={printTemplate} checkBrightness={checkBrightness} isLoading={isLoading} />
        {t("Reports.modalDetailP.caption")}
        <Typography>
          <CheckCircleIcon className="icon has-text-success" sx={{ fontSize: "15px" }} /> {t("Reports.modalDetailP.conformityAssessment")}
        </Typography>
        <Typography>
          <CancelIcon className="icon has-text-danger" sx={{ fontSize: "15px" }} /> {t("Reports.modalDetailP.nonConformityAssessment")}
        </Typography>
        <Typography variant="h4" textAlign="center" paddingTop={1} paddingBottom={1} sx={{ wordBreak: "break-word" }}>
          {selected?.formulario ? selected.formulario : selected?.nome}
        </Typography>
        <Divider variant="middle" />
        {showHeaders && <HeaderItens />}
        {exibeDetalheHospedeiro && selected?.detalheHospedeiro && <InfoHospedeiro hospedeiro={selected?.detalheHospedeiro} />}
        {(selected?.chamadosConfig || (!selected?.chamadosConfig && selected?.chamados && selected?.chamados.length)) && (
          <>
            {selected.chamadosConfig && (
              <TicketListReportComponent
                addingTickets={{
                  source: { itemId: null, subitemId: null, ocorrenciaId: null },
                  active: true,
                }}
                chamadosObj={selected.chamados}
                chamadosConfig={selected.chamadosConfig}
                formId={selected.idForm ? selected.idForm : selected.id || "-"}
                inicio={Number(selected.inicio)}
                commingFromSub={false}
                chamadosConfigSub={undefined}
                selected={selected}
              />
            )}
          </>
        )}
        {!hideAprov && selected?.nomeAprovador && selected?.nomeAprovador?.length > 0 && (
          <ListaAprovadores listaAprovadores={selected?.nomeAprovador} />
        )}
        {chamados && radioOption !== "hide" && (
          <ChamadosDetalhe
            showDuplicatas={showDuplicatas}
            radioOption={radioOption}
            chamadosArray={chamados}
            form={selected as ChecklistReportType}
          />
        )}
        <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={1} marginTop={1}>
          {temArquivos() && (
            <Button endIcon={hideAllFiles ? <RemoveRedEyeIcon /> : <VisibilityOffIcon />} onClick={toggleHideAllFiles}>
              {hideAllFiles ? t("Reports.showAllFiles") : t("Reports.hideAllFiles")}
            </Button>
          )}
          {temImagens() && (
            <Button endIcon={hideAllImages ? <RemoveRedEyeIcon /> : <VisibilityOffIcon />} onClick={toggleHideAllImages}>
              {hideAllImages ? t("Reports.showAllImages") : t("Reports.hideAllImages")}
            </Button>
          )}
        </Stack>
        {selected?.itens?.map((item, itemIndex) => {
          if (item.ocorrenciaMultipla && item.ocorrencias) {
            return (
              <main key={itemIndex}>
                {chamados?.ticketDetails && radioOption !== "hide" && (
                  <ChamadosDetalhe
                    showDuplicatas={showDuplicatas}
                    radioOption={radioOption}
                    chamadosArray={chamados}
                    form={selected as ChecklistReportType}
                  />
                )}
                <Typography style={{ color: "gray" }} variant="h5">
                  {item.nome} (Item de Ocorrencia Múltipla)
                </Typography>
                <Typography variant="h6">Ocorrencias:</Typography>
                {item?.ocorrencias?.map((ocorrencia, index) => {
                  return !ocorrencia.subitens?.some((sub) => sub?.checked) ? (
                    <></>
                  ) : (
                    <>
                      <ModalDetailContent
                        hideAllFiles={hideAllFiles}
                        hideAllImages={hideAllImages}
                        showNumbers={showNumbers}
                        exibeTipo={exibeTipo}
                        key={index}
                        itemIndex={itemIndex}
                        showScoring={showScoring}
                        item={ocorrencia}
                        parentItem={item}
                        ocorrencia={ocorrencia}
                        selected={selected}
                        showNotSelected={showNotSelected}
                        hideNAplica={hideNAplica}
                      />
                    </>
                  );
                })}
              </main>
            );
          } else
            return !item.subitens?.some((sub) => sub.checked) ? (
              <></>
            ) : (
              <ModalDetailContent
                showNumbers={showNumbers}
                exibeTipo={exibeTipo}
                itemIndex={itemIndex}
                showScoring={showScoring}
                item={item}
                parentItem={item}
                selected={selected}
                showNotSelected={showNotSelected}
                hideNAplica={hideNAplica}
                hideAllFiles={hideAllFiles}
                hideAllImages={hideAllImages}
              />
            );
        })}
        {selected?.aprovacaoStatus === "Aprovado" && selected.nomeAprovador && (
          <Stack direction="row" alignItems="center" justifyContent="flex-start" spacing={0.5}>
            <Typography color="textDisabled" variant="subtitle2" fontSize={13} fontWeight={600}>
              Aprovado por:
            </Typography>
            {selected?.nomeAprovador?.map(
              (ele) => ele.assinado && <Assinatura key={ele.dataAvaliacao} url={ele.assinatura} aprovadoEm={ele.dataAvaliacao} />,
            )}
          </Stack>
        )}
        <FooterModalDetailPrint printTemplate={printTemplate} checkBrightness={checkBrightness} isLoading={isLoading} />
      </Stack>
    </>
  );
}
